import { Component, OnInit, Pipe, ViewChild } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faFileExport,
  faInfoCircle,
  faLink,
  faLock,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTasks,
  faTimes,
  faTrashAlt,
  faUser,
  faBug,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PlannerComponent } from '../planner/planner.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
declare var $: any;
import { UserManagementService } from '../shared/services/user-management.service';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { JiraUserService } from '../shared/services/jira-user.service';
import { IfStmt } from '@angular/compiler';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
Chart.register(...registerables);
Chart.register(ChartDataLabels);

@Component({
  selector: 'app-jirabugs-mapper',
  templateUrl: './jirabugs-mapper.component.html',
  styleUrls: ['./jirabugs-mapper.component.scss']
})
export class JirabugsMapperComponent implements OnInit {
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faLink = faLink;
  faTrashAlt = faTrashAlt;
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  faRedo = faRedo;
  faSave = faSave;
  faPlus = faPlus;
  faTrash = faTrash;
  faSearch = faSearch;
  faLock = faLock;
  faBug = faBug;
  faTimes = faTimes;
  faEdit = faEdit;
  faTasks = faTasks;
  jiraProjectData: any;
  index: any = 0;
  totalNotificationCount: any = 0;
  nextCount: any = 0;
  prevCount: any = 0;
  buglist: any;
  skipNotifyCount: any = 0;
  maxNotifyCount: any = 0;
  selectedfilter: any = "10001";
  selectedfilterName: any = "One week";
  currentTab: any = 'import';
  showText = false;
  defectSetname: any = '';
  importType: any = 'Import from';
  primaryLevel: any = '';
  // faCircle = faCircle;
  // faCheckCircle = faCheckCircle;
  // faSearch = faSearch;
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart: any;
  myTopScrollBtn = document.getElementById('scrollToTpBtn');
  headerbugID: any;
  headersummary: any;
  headerdescription: any;
  headercreatedOn: any;
  userName: any;
  projectName: any;
  comparative: boolean = false;
  projectId: any;
  jiraFilters: any = [];
  CSVimportList: any = [];
  projectDefectSets: any = [];
  importListBugs: any = [];
  importTypes: any = ["CSV", "Jira", "Others"];
  filters: any = [{ "name": "last week", "value": "10001" }, { "name": "Bugs", "value": "10002" }, { "name": "Last month", "value": "10003" }];
  levels: any = ["L8", "L7", "L6", "L5", "L4", "L123"];
  project: any = { projectDetails: { name: '', description: '' }, jiraProjectDetails: { name: '', id: '', url: '' } };
  jiraLogin: any = { username: 'sreesailam.avinash489@gmail.com', password: 'M3rOpjkP29RxanDi6Y0QFF3F', jiraurl: 'https://dosmarttesting.atlassian.net' };
  // jiraLogin: any = { username: '', password: '', jiraurl: '' };
  loginDetails: any;
  jiraProjectUrDetails: any;
  selectedDefectSet: any = '';
  compareDefectSet: any = '';
  modelData: any;
  jiraBugs: any;
  jiraStoriesList: any = [];
  jiraBugsList: any = [];
  selectedBugs: any = [];
  multipleBugsArray: any = [];
  prioritylevelSelected: any = [];
  projectjirsBugsLevels: any = [];
  selectedlevel: any = "Choose";
  searchText: any = '';
  searchfilter: any = '';
  updateDefectSetname: any = true;
  oldDefectSetName: any = '';
  projectDefectSetsBugs: any = [];
  parsedCsv: any;
  csvContent: any;
  CSVheaders: any = [];
  CSVvalues: any = [];
  dataSets: any = [];
  bugsDefectSetLevelChart: any = '';
  levelsCountBugsDefectSet: any = [];
  bugsDefectSetLevelWiseChart: any = '';
  listOfAttributes: any = [
    {
      name: 'Migration',
      symbol: 'Mi',
      level: 'L8',
    },
    {
      name: 'Installation',
      symbol: 'In',
      level: 'L8',
    },
    {
      name: 'Configuration',
      symbol: 'Co',
      level: 'L8',
    },
    {
      name: 'System Integration',
      symbol: 'Si',
      level: 'L8',
    },
    {
      name: 'Performance',
      symbol: 'Pf',
      level: 'L7',
    },
    {
      name: 'Load',
      symbol: 'Lo',
      level: 'L7',
    },
    {
      name: 'Reliability',
      symbol: 'Re',
      level: 'L7',
    },
    {
      name: 'Security',
      symbol: 'Se',
      level: 'L7',
    },
    {
      name: 'Usability',
      symbol: 'Us',
      level: 'L7',
    },
    {
      name: 'Browser Compatibility',
      symbol: 'Bc',
      level: 'L6',
    },
    {
      name: 'Environment Compatibility',
      symbol: 'Ec',
      level: 'L6',
    },
    {
      name: 'Requirement Behaviour',
      symbol: 'Rb',
      level: 'L5',
    },
    {
      name: 'Flow Behaviour',
      symbol: 'Fb',
      level: 'L5',
    },
    {
      name: 'Feature Behaviour',
      symbol: 'Fe',
      level: 'L4',
    },
    {
      name: 'Access Control',
      symbol: 'Ac',
      level: 'L4',
    },
    {
      name: 'UI Interface',
      symbol: 'Ui',
      level: 'L123',
    },
    {
      name: 'Structural Behaviour',
      symbol: 'St',
      level: 'L123',
    },
    // {
    //   name: 'Data Validation',
    //   symbol: 'Dt',
    //   level: 'L123',
    // },
  ];
  level4Data: any = [];
  level5Data: any = [];
  level6Data: any = [];
  level7Data: any = [];
  level8Data: any = [];
  config: any;
  smartChecklist: boolean = true;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private cookieService: CookieService,
    private reloadToolService: ReloadToolService,
    private AppService: AppService,
    private Config: Config,
    public translate: TranslateService,
    private JiraUserService: JiraUserService
  ) { }

  ngOnInit(): void {
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    // this.loadData();
    this.modelData = this._sharedService.loadedProjectData.model;
    this.jiraBugs = this.modelData.jiraBugs;
    this.userName = window.localStorage.getItem('userName');
    this.projectName = window.localStorage.getItem('projectName');
    this.projectId = window.localStorage.getItem('projectID');
    this.config = this.Config;
    this.getLatestBugs();
    this.getDefectsSets();
    // this.selectedBugs = this.modelData.jiraBugs;
  }

  chooseDefectSet(defectSet: any) {
    if (this.selectedDefectSet != '') {
      this.bugsDefectSetLevelChart.destroy();
    }
    this.selectedDefectSet = defectSet;
    this.dataSets = [];
    this.compareDefectSet = '';
    this.comparative = false;
    this.getBugsByDefectSet(this.selectedDefectSet._id);

  }
  chooseCompareDefectSet(defectSet: any) {
    // if (this.compareDefectSet != '') {
    //   this.bugsDefectSetLevelChart.destroy();
    // }
    this.compareDefectSet = defectSet;
    this.getBugsByDefectSet(this.compareDefectSet._id);
    this.bugsDefectSetLevelChart.destroy();

  }
  getBugsByDefectSet(id: any) {
    this.ProjectServices.getBugsByDefectsSets(id).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.projectDefectSetsBugs = response.records;
        this.generateBugsReport();
        this.generateBugsLevelwisereport();
      } else {
      }
    });
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  compareDefectSets(checked: any) {
    this.comparative = checked;
    if (checked == false) {
      // if(this.dataSets.length > 1){
      this.compareDefectSet = '';
      this.bugsDefectSetLevelChart.destroy();
      this.dataSets = [];
      this.getBugsByDefectSet(this.selectedDefectSet._id);
      // }
    }
  }
  generateBugsReport() {
    this.levelsCountBugsDefectSet = [];
    // console.log("A", this.projectDefectSetsBugs);
    var level123Count = 0;
    // var level45Count = 0;
    // var level678Count = 0;
    // var level1Count = 0;
    // var level2Count = 0;
    // var level3Count = 0;
    var level4Count = 0;
    var level5Count = 0;
    var level6Count = 0;
    var level7Count = 0;
    var level8Count = 0;
    for (var i = 0; i < this.projectDefectSetsBugs.length; i++) {
      // if (this.projectDefectSetsBugs[i].level == "L123") {
      //   level123Count++;
      // } else if (this.projectDefectSetsBugs[i].level == "L45") {
      //   level45Count++;
      // } else if (this.projectDefectSetsBugs[i].level == "L678") {
      //   level678Count++;
      // } else 
      // if (this.projectDefectSetsBugs[i].level == "L1") {
      //   level1Count++;
      // } else if (this.projectDefectSetsBugs[i].level == "L2") {
      //   level2Count++;
      // } else if (this.projectDefectSetsBugs[i].level == "L3") {
      //   level3Count++;
      // } else
      if (this.projectDefectSetsBugs[i].level == "L123") {
        level123Count++;
      } else if (this.projectDefectSetsBugs[i].level == "L4") {
        level4Count++;
      } else if (this.projectDefectSetsBugs[i].level == "L5") {
        level5Count++;
      } else if (this.projectDefectSetsBugs[i].level == "L6") {
        level6Count++;
      } else if (this.projectDefectSetsBugs[i].level == "L7") {
        level7Count++;
      } else if (this.projectDefectSetsBugs[i].level == "L8") {
        level8Count++;
      }
    }
    // level123Count, level45Count, level678Count, 
    this.levelsCountBugsDefectSet.push(level8Count,
      level7Count, level6Count, level5Count, level4Count, level123Count);
    // console.log(this.levelsCountBugsDefectSet);
    if (this.comparative == false) {
      var backgroundColor = 'rgb(54, 162, 235)';
      var label = this.selectedDefectSet.name;
    } else {
      var label = this.compareDefectSet.name;
      var backgroundColor = 'rgb(255, 124, 86)';
    }
    if (this.dataSets.length > 1) {
      this.dataSets.splice(-1, 1);
    }
    this.dataSets.push({
      label: label,
      data: this.levelsCountBugsDefectSet,
      backgroundColor: backgroundColor,
      stack: 'Stack 0',
    })
    this.generateLevelDefectSetBugsCharts();
    this.generateLevelDefectSetBugsLineCharts();
  }

  generateBugsLevelwisereport() {

    const arrDates = this.projectDefectSetsBugs.map((str: any) => new Date(str.created));

    const min = new Date(Math.min(...arrDates));
    // console.log("Min",min); // 👉️ Sat Sep 24 2022

    const max = new Date(Math.max(...arrDates));
    // console.log("Max",max); // 👉️ Thu Jul 17 2025
    const date1: any = new Date(min);
    const date2: any = new Date(max);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // console.log(diffTime + " milliseconds");
    // console.log(diffDays + " days");

    for (var i = 0; i < this.projectDefectSetsBugs.length; i++) {
      // console.log(this.projectDefectSetsBugs[i]);
      // var date = new Date(this.projectDefectSetsBugs[i].created);
      // console.log(date.getDay(),"-",date.getMonth() + 1,"-",date.getFullYear());
      var difference = this.calculateDaysBetweenDates(min, new Date(this.projectDefectSetsBugs[i].created));
      if (this.projectDefectSetsBugs[i].level == "L4") {
        this.level4Data.push(difference);
      } else if (this.projectDefectSetsBugs[i].level == "L5") {
        this.level5Data.push(difference);
      } else if (this.projectDefectSetsBugs[i].level == "L6") {
        this.level6Data.push(difference);
      } else if (this.projectDefectSetsBugs[i].level == "L7") {
        this.level7Data.push(difference);
      } else if (this.projectDefectSetsBugs[i].level == "L8") {
        this.level8Data.push(difference);
      }
    }
    // console.log(this.level4Data.sort((a: any, b: any) => a - b));
    // console.log(this.level5Data.sort((a: any, b: any) => a - b));
    // console.log(this.level6Data.sort((a: any, b: any) => a - b));
    // console.log(this.level7Data.sort((a: any, b: any) => a - b));
    // console.log(this.level8Data.sort((a: any, b: any) => a - b));
  }

  calculateDaysBetweenDates(date1: any, date2: any) {
    // console.log(date1);
    // console.log(date2);
    var oneDay = 24 * 60 * 60 * 1000;
    var date1InMillis = date1.getTime();
    var date2InMillis = date2.getTime();
    var days = Math.round(Math.abs(date2InMillis - date1InMillis) / oneDay);
    return days;
  }
  generateLevelDefectSetBugsCharts() {

    this.bugsDefectSetLevelChart = new Chart("FuctionalEUTpie", {
      type: 'bar',
      data: {
        labels: this.levels,
        datasets: this.dataSets
      },
      options: {
        //   hover: {
        //     mode: null
        //  },
        indexAxis: 'y',
        scales: {
          x:
          {
            stacked: true,
            grid: {
              drawBorder: true,
              color: function (context) {
                if (context.tick.value == 0) {
                  return '#000000';
                } else {
                  return '#DCDBDB';
                }

              },
            },
            ticks: {
              display: true,
            }
          }

        },
        plugins: {
          datalabels: {
            // formatter: function (value, context: any) {
            //   console.log("index", context.dataIndex, value);
            //   var label = labelsChart[context.dataIndex] + '(' + value + ')';
            //   labelsChart[context.dataIndex] = "-ve";
            //   return label;
            // },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },
          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Level-wise distribution',
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
  };
  generateLevelDefectSetBugsLineCharts() {

    // const datapoints = [5, 10, 18, 22, 29];
    // const datapoints1 = [5, 24, 33, 42, 48];
    // const datapoints2 = [1, 8, 15, 20, 25];
    const datapoints3 = this.level4Data;
    const datapoints4 = this.level4Data;
    const datapoints5 = this.level4Data;
    const datapoints6 = this.level4Data;
    const datapoints7 = this.level4Data;
    this.bugsDefectSetLevelWiseChart = new Chart("defectSetLineChart", {
      type: 'line',
      data: {
        labels: ["0%", "25%", "50%", "75%", "100%"],
        datasets: [
          // {
          //   label: 'L1',
          //   data: datapoints,
          //   borderColor: 'red'
          // },
          // {
          //   label: 'L2',
          //   data: datapoints1,
          //   borderColor: 'green'
          // },
          // {
          //   label: 'L3',
          //   data: datapoints2,
          //   borderColor: 'purple'
          // },
          {
            label: 'L4',
            data: this.level4Data,
            borderColor: 'black'
          },
          {
            label: 'L5',
            data: this.level5Data,
            borderColor: 'blue'
          },
          {
            label: 'L6',
            data: this.level6Data,
            borderColor: 'yellow'
          }, {
            label: 'L7',
            data: this.level7Data,
            borderColor: 'brown'
          },
          {
            label: 'L8',
            data: this.level8Data,
            borderColor: 'orange'
          }
        ]
      },
      options: {
        responsive: true,
        indexAxis: 'x',
        scales: {
          y: {
            display: true,
            // ticks: {
            //     min: 0,  
            //     steps: 10,
            //     stepValue: 5,
            //     max: 100
            // }
          }

        },
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Level-wise growth'
          }
        }
      },
    });
  };

  getLatestBugs() {
    this.getProjectData();
    this.getProjectJiraBugs();
    setTimeout(() => {
      this.getLatestJiraFilters();
    }, 1000);

  }
  // changeListener(files: FileList) {
  //   console.log(files);
  //   // if(files && files.length > 0) {
  //   //    let file : File = files.item(0); 
  //   //      console.log(file.name);
  //   //      console.log(file.size);
  //   //      console.log(file.type);
  //   //      let reader: FileReader = new FileReader();
  //   //      reader.readAsText(file);
  //   //      reader.onload = (e) => {
  //   //         let csv: string = reader.result as string;
  //   //         console.log(csv);
  //   //      }
  //   //   }
  // }
  AddchooseDefectSet(newButton: any, textBox: any, suite: any) {
    // console.log("textBox", textBox);
    // this.new = newButton;
    this.showText = textBox;
    // this.selectedSuite = suite;
  }
  editDefectSet(oldName: any) {
    this.showText = true;
    this.updateDefectSetname = true;
    this.oldDefectSetName = oldName;
  }
  getDefectsSets() {
    this.ProjectServices.getDefectsSets(window.localStorage.getItem('projectID')).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.projectDefectSets = response.records;

      } else {
      }
    });
  }
  getProjectJiraBugs() {
    this.ProjectServices.getProjectJirabugs(
      window.localStorage.getItem('projectID')
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.projectjirsBugsLevels = response.record;

      } else {
      }
    });
  }
  getProjectData() {
    this.ProjectServices.getProject(
      window.localStorage.getItem('projectID')
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.project = response.record;
        // console.log('this.project', this.project.invites);
        this.getProjectTasksList(response.record);
      } else {
      }
    });
  }
  getProjectTasksList(proDetails: any) {
    if (proDetails.jiraProjectDetails.url) {
      this.jiraProjectUrDetails = this.loginDetails.jiraDetails.find(
        (det: any) => det.url == proDetails.jiraProjectDetails.url
      );
      this.jiraLogin = { username: this.jiraProjectUrDetails.email, password: this.jiraProjectUrDetails.token, jiraurl: this.jiraProjectUrDetails.url };
      let authorizationData = 'Basic ' + btoa(this.jiraProjectUrDetails.email + ':' + this.jiraProjectUrDetails.token);
      this.JiraUserService.getAllJiraBugs(authorizationData, proDetails.jiraProjectDetails, this.skipNotifyCount, this.selectedfilter).subscribe((response: any) => {

        this.jiraStoriesList = response.issues;


        this.loadData(response.issues);
      });
    } else {
      // this.jiraLogin = { username: '', password: '', jiraurl: '' };
    }
  }
  getLatestJiraFilters() {

    let authorizationData = 'Basic ' + btoa(this.jiraProjectUrDetails.email + ':' + this.jiraProjectUrDetails.token);

    this.JiraUserService.getJiraFilters(
      authorizationData, this.project.jiraProjectDetails
    ).subscribe((response: any) => {
      this.jiraFilters = response.values;
    });
  }
  loadData(pro: any) {
    this.jiraProjectData = pro;
    this.jiraBugsList = [];
    // console.log("this.projectjirsBugsLevels", this.projectjirsBugsLevels);
    // console.log("this.jiraStoriesList", this.jiraStoriesList);
    // for (var i = 0; i < this.projectjirsBugsLevels.length; i++) {
    //   if (this.jiraStoriesList.length > 0) {
    //     for (var j = 0; j < this.jiraStoriesList.length; j++) {
    //       if (this.projectjirsBugsLevels[i].summary == this.jiraStoriesList[j].fields.summary) {

    //         this.jiraBugsList.push(this.projectjirsBugsLevels[i]);

    //       } else {
    //         var found = this.projectjirsBugsLevels.find((index: any) => index.summary == this.jiraStoriesList[j].fields.summary);
    //         if (!found) {
    //           var found1 = this.jiraBugsList.find((index: any) => index.summary == this.jiraStoriesList[j].fields.summary);
    //           if (!found1) {
    //             let obj = { "jiraID": this.jiraStoriesList[j].id, "summary": this.jiraStoriesList[j].fields.summary, "description": this.jiraStoriesList[j].fields.description, "created": this.jiraStoriesList[j].fields.created, "level": "" };
    //             this.jiraBugsList.push(obj);
    //           }

    //         }

    //       }
    //     }
    //   } else {
    //     let obj = { "jiraID": this.projectjirsBugsLevels[i].jiraID, "summary": this.projectjirsBugsLevels[i].fields.summary, "description": this.projectjirsBugsLevels[i].fields.description, "created": this.projectjirsBugsLevels[i].fields.created, "level": "" };
    //     this.jiraBugsList.push(this.projectjirsBugsLevels[i]);
    //   }
    // };

    if (this.jiraStoriesList.length > 0) {
      for (var i = 0; i < this.jiraStoriesList.length; i++) {
        if (this.projectjirsBugsLevels.length > 0) {
          var found = this.projectjirsBugsLevels.find((index: any) => index.jiraID == this.jiraStoriesList[i].id);
          if (found) {
            this.jiraBugsList.push(found);
          }
          if (!found) {
            let obj = { "jiraID": this.jiraStoriesList[i].id, "summary": this.jiraStoriesList[i].fields.summary, "description": this.jiraStoriesList[i].fields.description, "created": this.jiraStoriesList[i].fields.created, "level": "" };
            this.jiraBugsList.push(obj);
          }
        } else {
          let obj = { "jiraID": this.jiraStoriesList[i].id, "summary": this.jiraStoriesList[i].fields.summary, "description": this.jiraStoriesList[i].fields.description, "created": this.jiraStoriesList[i].fields.created, "level": "" };
          this.jiraBugsList.push(obj);
        }
      };
    }
    // console.log("this.jiraStoriesList", this.jiraBugsList);

  }
  isChecked(summary: any) {
    var bug = this.selectedBugs.findIndex(
      (jira: any) => jira.summary == summary
    );
    if (bug == -1) {
      return false;
    } else {
      return true;
    }
  };
  selectAll(checked: any) {
    if (checked == true) {
      this.selectedBugs = this.jiraBugsList;
    } else {
      this.selectedBugs = [];
    }
  }
  chooseFilter(filter: any) {
    this.selectedfilter = filter.id;
    this.selectedfilterName = filter.name;
    this.getLatestBugs();
  }
  chooseImportType(type: any) {
    this.importType = type;
    this.getLatestBugs();
  }
  chooseMainLevel(level: any) {
    this.primaryLevel = level;
    // console.log(this.multipleBugsArray);
    if (this.multipleBugsArray.length > 0) {
      var obj = {
        "ids": this.multipleBugsArray,
        "level": level
      };

      this.ProjectServices.updateDefectSetBugLevel(obj).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.getBugsByDefectSet(this.selectedDefectSet._id);
          this.multipleBugsArray = [];
        } else {
        }
      });
    }
  }

  addToPriorityFilter(priority: any, isChecked: any) {
    if (isChecked) {
      this.prioritylevelSelected.push(priority);
    } else {
      var isPresent = this.prioritylevelSelected.findIndex(
        (p: any) => p == priority
      );
      if (isPresent > -1) {
        this.prioritylevelSelected.splice(isPresent, 1);
      }
    }
    this.getBugsByDefectSet(this.selectedDefectSet._id);
    // this.countScenarioEUTType(this.allScenarios);
    // if (this.topSelectedList.length != 0) {
    //   this.addAllFromScenarios(false);
    //   // document.getElementById("selectAllAdd").checked = false;
    // }
  }
  chooseLevel(bug: any, level: any) {
    // console.log("bug", bug, level);
    // this.selectedlevel = level;
    // var exists = this.projectjirsBugsLevels.find((ji: any) => ji.jiraID == bug.jiraID);
    // // console.log("exists", exists);
    // if (exists) {
    // console.log("exists", exists);
    this.updateJiraBugLevel(bug._id, level);
    // } else {
    //   // console.log("Not-exists", exists);
    //   this.selectedBugs = [];
    //   let obj = { "jiraID": bug.jiraID, "summary": bug.summary, "description": bug.description, "created": bug.created, "level": level };
    //   this.selectedBugs.push(obj);
    //   this.saveSelectedBugs();
    // }
  }

  selectAllBugs(isSelectAllChecked: any) {
    if (isSelectAllChecked) {
      if (this.prioritylevelSelected.length > 0 && this.searchText) {
        for (var i = 0; i < this.projectDefectSetsBugs.length; i++) {
          var isPresent = this.prioritylevelSelected.findIndex((a: any) => a == this.projectDefectSetsBugs[i].level);
          if (isPresent > -1 && this.projectDefectSetsBugs[i].summary.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())) {
            this.multipleBugsArray.push(this.projectDefectSetsBugs[i]._id)
          }
        }
      } else {
        for (var i = 0; i < this.projectDefectSetsBugs.length; i++) {
          this.multipleBugsArray.push(this.projectDefectSetsBugs[i]._id)
        }
      }

    } else {
      this.multipleBugsArray = [];
    }
    // console.log("ids", this.multipleBugsArray);
  }

  addtoMultipleBugs(id: any, isChecked: any) {
    console.log(id, isChecked);

    if (isChecked) {
      this.multipleBugsArray.push(id);
    } else {
      var isPresent = this.multipleBugsArray.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.multipleBugsArray.splice(isPresent, 1);
      }
    }
    // console.log(this.multipleBugsArray);
  }
  updateJiraBugLevel(ID: any, level: any) {
    var bugsArray = [ID];
    var obj = {
      "ids": bugsArray,
      "level": level
    };

    this.ProjectServices.updateDefectSetBugLevel(obj).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.getBugsByDefectSet(this.selectedDefectSet._id);
      } else {
      }
    });
  };
  selectBug(checked: any, bug: any) {
    // console.log("selectedBug",checked, bug);
    if (checked == true) {
      let obj = { "jiraID": bug.jiraID, "summary": bug.summary, "description": bug.description, "created": bug.created, "level": this.selectedlevel };
      this.selectedBugs.push(obj);
    } else {
      var index = this.selectedBugs.findIndex((index: any) => index.summary == bug.summary);
      this.selectedBugs.slice(index, -1);
    }
    // console.log("selectedBug", this.selectedBugs);
  };

  saveSelectedBugs() {
    // console.log("this.selectedBugs", this.selectedBugs);
    if (this.selectedBugs.length > 0) {
      for (var i = 0; i < this.selectedBugs.length; i++) {
        this.selectedBugs[i]['projectID'] = this.projectId;
        this.ProjectServices.addDefectSetBug(this.selectedBugs[i]).subscribe(
          (response: any) => {
            if (response.statusCode === 200) {
              // console.log("response", response);
              this.getLatestBugs();
            } else if (response.statusCode === 500) {
            }
          }
        );
      }
    }
  }

  checkExists(bug: any) {

    var exists = this.modelData.jiraBugs.find((ji: any) => ji.summary == bug);
    if (!exists) {
      return true;
    } else {
      return false;
    }
  }
  changeTab(tabName: any) {
    this.currentTab = tabName;
    // console.log(this.currentTab);
  };
  clear() {
    this.showText = false;

  }
  resetImport() {
    this.importType = 'Import from';
    this.jiraStoriesList = [];
    this.CSVheaders = [];
    this.CSVvalues = [];
    this.importListBugs = [];
    this.selectedDefectSet = "";
    this.projectDefectSetsBugs = [];
  }
  savedefectSet() {
    var obj = {
      "name": this.defectSetname,
      "projectID": this.projectId
    }
    this.ProjectServices.addDefectSet(obj).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.getDefectsSets();
          this.clear();
          this.defectSetname = '';
        } else if (response.statusCode === 201) {
          alert(response.message);
        }
      }
    );
  };

  importDefects() {
    // console.log(this.selectedDefectSet);
    // console.log(this.jiraStoriesList);
    // console.log(this.importType);
    this.importListBugs = [];
    if (this.selectedDefectSet) {
      if (this.importType == 'Jira') {
        for (var j = 0; j < this.jiraStoriesList.length; j++) {
          var bug = {
            "bugID": this.jiraStoriesList[j].id,
            "defectSetID": this.selectedDefectSet._id,
            "projectID": this.selectedDefectSet.projectID,
            "summary": this.jiraStoriesList[j].fields.summary,
            "description": this.jiraStoriesList[j].fields.description,
            "created": this.jiraStoriesList[j].fields.created,
            "level": ''
          }
          this.importListBugs.push(bug);
        }
        // console.log(this.importListBugs);
      } else if (this.importType == 'CSV') {
        if (this.CSVimportList.length > 0) {
          for (var i = 0; i < this.CSVimportList.length; i++) {
            var bug = {
              "bugID": this.CSVimportList[i].id,
              "defectSetID": this.selectedDefectSet._id,
              "projectID": this.selectedDefectSet.projectID,
              "summary": this.CSVimportList[i].summary,
              "description": this.CSVimportList[i].description,
              "created": this.CSVimportList[i].created,
              "level": ''
            }
            this.importListBugs.push(bug);
          }
        } else {
          alert("Generate list before import");
        }
      }
    } else {
      alert("Choose Defectset");
    }
    // this.updateDefectSetBugs();
  }

  updateDefectSetBugs() {
    // console.log(this.importListBugs);
    for (var i = 0; i < this.importListBugs.length; i++) {
      this.ProjectServices.addDefectSetBug(this.importListBugs[i]).subscribe(
        (response: any) => {
          if (response.statusCode === 200 || response.statusCode === 201) {


          } else if (response.statusCode === 500) {
          }
        }
      );
      if (i == this.importListBugs.length - 1) {
        var message = 'Successfully ' + this.importListBugs.length + ' defects imported';
        alert(message);
        this.resetImport();
      }
    }

  }


  // Read CSV file Headers and values
  changeListener(files: FileList) {
    // console.log(files);
    this.CSVheaders = [];
    this.CSVvalues = [];
    if (files && files.length > 0) {
      let file: any = files.item(0);
      //  console.log(file.name);
      //  console.log(file.size);
      //  console.log(file.type);
      //File reader method
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: any = reader.result;
        let allTextLines = [];
        allTextLines = csv.split(/\r|\n|\r/);

        //Table Headings
        // console.log(allTextLines[0]);
        let headers = allTextLines[0].split(',');
        // console.log("headers", headers);
        let data = headers;
        let tarr = [];
        for (let j = 0; j < headers.length; j++) {
          this.CSVheaders.push(data[j].replace(/[^a-zA-Z ]/g, ""));
        }
        // console.log(this.CSVheaders);
        //Pusd headings to array variable
        // this.CSVheaders.push(tarr);


        // Table Rows
        let tarrR = [];

        let arrl = allTextLines.length;
        // alert(arrl);
        let rows = [];
        for (let i = 1; i < arrl; i++) {
          this.CSVvalues.push(allTextLines[i].split(','));

        }
        // console.log("this.CSVvalues", this.CSVvalues);
        // for (let j = 0; j < arrl; j++) {

        //   this.CSVvalues.push(rows[j]);

        // }
        //Push rows to array variable
        //  if(tarrR.length > 0){
        //   this.CSVvalues.push(tarrR);

        //  }
      }
      // console.log(this.CSVheaders);
      // console.log(this.CSVvalues);
    }

  }

  chooseHeader(type: any, key: any) {
    if (type == 'bugID') {
      this.headerbugID = key;
    } else if (type == 'summary') {
      this.headersummary = key;
    } else if (type == 'desc') {
      this.headerdescription = key;
    } else if (type == 'created') {
      this.headercreatedOn = key;
    }
  }
  generateViewdata() {
    // console.log(this.CSVheaders.indexOf(this.headerbugID), this.CSVheaders.indexOf(this.headersummary),
    //   this.CSVheaders.indexOf(this.headerdescription), this.CSVheaders.indexOf(this.headercreatedOn));
    // console.log(this.CSVvalues);
    // if (this.headerbugID && this.headersummary && this.headerdescription && this.headercreatedOn) {
    //   for (var j = 0; j < this.CSVvalues.length; j++) {
    //     if (this.CSVvalues[j].length > 1) {
    //       let obj = {
    //         "id": this.CSVvalues[j][this.CSVheaders.indexOf(this.headerbugID)],
    //         "summary": this.CSVvalues[j][this.CSVheaders.indexOf(this.headersummary)],
    //         "description": this.CSVvalues[j][this.CSVheaders.indexOf(this.headerdescription)],
    //         "created": this.CSVvalues[j][this.CSVheaders.indexOf(this.headercreatedOn)],
    //       };
    //       this.CSVimportList.push(obj);
    //     }

    //   }
    // } else {
    //   alert("Set mapping before viewing");
    // }

    // console.log(this.importType);
    // console.log(this.jiraStoriesList);
    this.importListBugs = [];
    if (this.selectedDefectSet) {
      if (this.importType == 'Jira') {
        for (var i = 0; i < this.jiraStoriesList.length; i++) {
          var bug = {
            "bugID": this.jiraStoriesList[i].id,
            "defectSetID": this.selectedDefectSet._id,
            "projectID": this.selectedDefectSet.projectID,
            "summary": this.jiraStoriesList[i].fields.summary,
            "description": this.jiraStoriesList[i].fields.description,
            "created": this.jiraStoriesList[i].fields.created,
            "level": ''
          }
          this.importListBugs.push(bug);
        }
        // console.log(this.importListBugs);
      } else if (this.importType == 'CSV') {

        if (this.headerbugID && this.headersummary && this.headerdescription && this.headercreatedOn) {
          for (var j = 0; j < this.CSVvalues.length; j++) {
            if (this.CSVvalues[j].length > 1) {
              let obj = {
                "bugID": this.CSVvalues[j][this.CSVheaders.indexOf(this.headerbugID)],
                "defectSetID": this.selectedDefectSet._id,
                "projectID": this.selectedDefectSet.projectID,
                "summary": this.CSVvalues[j][this.CSVheaders.indexOf(this.headersummary)],
                "description": this.CSVvalues[j][this.CSVheaders.indexOf(this.headerdescription)],
                "created": this.CSVvalues[j][this.CSVheaders.indexOf(this.headercreatedOn)],
                "level": ''
              };
              this.importListBugs.push(obj);
            }

          }
        } else {
          alert("Set mapping before viewing");
        }



      }
    } else {
      alert("Choose Defectset");
    }



    // console.log(this.importListBugs);
  }
}
